const formatMinutesIntoHoursAndMinutes = (minutes) =>
{            return [3600, 60]
    .reduceRight(
        (p, b) => r => [Math.floor(r / b)].concat(p(r % b)),
        r => [r]
    )(minutes * 60)
    .map(a => a.toString().padStart(2, '0'))
    .slice(0, -1)
    .join(':');
}

const truncate = (text, max) => {
    if (!text) return ""; // Verifica se text é null, undefined ou falsy
    if (text.length <= max) return text;
    return text.slice(0, max) + "...";
  }

const isNullOrWhitespace = (input) => !input || !input.trim();

export { formatMinutesIntoHoursAndMinutes, truncate, isNullOrWhitespace }